// AI Generated Component
import { Component, computed, input, Input, OnInit } from '@angular/core';
import { GlobalHelperService } from '@client/app/services/global-helper/global-helper.service';
import { MonTableCollection } from '@client/ng2/models/table-collection.interface';

@Component({
    selector: 'admin-auditlog-changes',
    standalone: false,
    template: `
        <div id="admin-audit-log-changes">
            <div class="mon-dialog-header">
                <page-header icon="fas fa-random" [header]="('Changes for' | translate) + ': ' + identifier"></page-header>
            </div>
            <div class="mon-dialog-body">
                <div class="card panel-monsido-card mt-4 mx-4">
                    <div class="card-body">
                        <table-container [collection]="collection()" [noResultMessage]="'No changes found' | translate">
                            <table class="table table-hover table-fixed">
                                <thead>
                                    <tr>
                                        <th class="col-sm-8 col-md-8" translate>Attribute</th>
                                        <th class="col-sm-8 col-md-8 text-right" translate>Before</th>
                                        <th class="col-sm-8 col-md-8" translate>After</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let change of $any(changes | keyvalue)"
                                        [hidden]="isBlacklisted(change.key)">
                                        <td>{{ change.key | underscoreless }}</td>
                                        <td class="text-right">
                                            <div class="bounding-box">
                                                <span class="bounding-box"
                                                      *ngFor="let item of $any(change.value[0] | keyvalue)"
                                                      [hidden]="!globalHelperService.isObject(change.value[0])">
                                                    <strong>{{ item.key | underscoreless }}:</strong>
                                                    <span *ngIf="item.value !== null">{{item.value | underscoreless | json}}</span>
                                                    <span *ngIf="item.value === null" class="text-italic" translate>Empty</span>
                                                    <br>
                                                </span>
                                                <span class="bounding-box"
                                                      *ngIf="!created && !globalHelperService.isObject(change.value[0])">
                                                    {{ change.value[0] }}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="bounding-box">
                                                <span *ngFor="let item of $any(change.value[1] | keyvalue); trackBy: trackByIndex"
                                                      [hidden]="!globalHelperService.isObject(change.value[1])">
                                                    <strong>{{ item.key | underscoreless }}:</strong>
                                                    <span *ngIf="item.value !== null">{{item.value | underscoreless | json}}</span>
                                                    <span *ngIf="item.value === null" class="text-italic" translate>Empty</span>
                                                    <br>
                                                </span>
                                                <span *ngIf="!globalHelperService.isObject(change.value[1])">
                                                    {{ change.value[1] }}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let relationChange of $any(relationshipChanges | keyvalue)">
                                        <td>{{ relationChange.key | underscoreless }}</td>
                                        <td class="text-right">
                                            <div class="bounding-box">
                                                <span *ngFor="let item of $any(relationChange.value[0] | keyvalue); trackBy: trackByIndex">
                                                    <ng-container [ngSwitch]="relationChange.key">
                                                        <span *ngSwitchCase="'path_constraints'">
                                                            <strong translate>Constraint: </strong>
                                                            <span>{{ item.value.constraint }}</span>
                                                            <br>
                                                        </span>
                                                        <span *ngSwitchCase="'link_excludes'">
                                                            <strong translate>Link excludes: </strong>
                                                            <span>{{ item.value.regex }}</span>
                                                            <br>
                                                        </span>
                                                        <span *ngSwitchDefault>
                                                            <span class="bounding-box"
                                                                  *ngFor="let objItem of $any(item.value | keyvalue); trackBy: trackByIndex"
                                                                  [hidden]="!globalHelperService.isObject(item.value) || relationChange.key === 'domain_users'">
                                                                <strong>{{ objItem.key | underscoreless }}:</strong>
                                                                <span *ngIf="objItem.value !== null">{{objItem.value | underscoreless}}</span>
                                                                <span *ngIf="objItem.value === null" class="text-italic" translate>Empty</span>
                                                                <br>
                                                            </span>
                                                            <br>
                                                        </span>
                                                    </ng-container>
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="bounding-box">
                                                <span *ngFor="let item of $any(relationChange.value[1] | keyvalue); trackBy: trackByIndex">
                                                    <ng-container [ngSwitch]="relationChange.key">
                                                        <span *ngSwitchCase="'path_constraints'">
                                                            <strong translate>Constraint: </strong>
                                                            <span>{{ item.value.constraint }}</span>
                                                            <br>
                                                        </span>
                                                        <span *ngSwitchCase="'link_excludes'">
                                                            <strong translate>Link excludes: </strong>
                                                            <span>{{ item.value.regex }}</span>
                                                            <br>
                                                        </span>
                                                        <span *ngSwitchDefault>
                                                            <span class="bounding-box"
                                                                  *ngFor="let objItem of item.value | keyvalue; trackBy: trackByIndex"
                                                                  [hidden]="!globalHelperService.isObject(item.value) || relationChange.key === 'domain_users'">
                                                                <strong>{{ objItem.key | underscoreless }}:</strong>
                                                                <span *ngIf="objItem.value !== null">{{objItem.value | underscoreless}}</span>
                                                                <span *ngIf="objItem.value === null" class="text-italic" translate>Empty</span>
                                                                <br>
                                                            </span>
                                                        </span>
                                                    </ng-container>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </table-container>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class AdminAuditlogChangesComponent implements OnInit {
    ngModel = input<any>();
    @Input() identifier: string = '';
    @Input() created: boolean = false;

    collection = computed(() => {
        const collection: MonTableCollection<void> = [];
        if (!this.ngModel()?.changes) {
            collection.total = 0;
            return collection;
        }
        const total = (Object.keys(this.ngModel()?.changes || {}) || []).length;
        collection.total = total;
        return collection;
    });

    changes: any = {};
    relationshipChanges: any = {};

    constructor (public globalHelperService: GlobalHelperService) {}

    ngOnInit (): void {
        this.changes = this.ngModel().changes;
        this.relationshipChanges = {};

        for (const key in this.ngModel().relationship_changes) {
            if (this.ngModel().relationship_changes.hasOwnProperty(key)) {
                if (!this.isSimilar(this.ngModel().relationship_changes[key][0], this.ngModel().relationship_changes[key][1])) {
                    this.relationshipChanges[key] = this.ngModel().relationship_changes[key];
                }
            }
        }
    }

    isBlacklisted (attr: any): boolean {
        return ['updated_at'].indexOf(attr) !== -1;
    }

    isSimilar (obj1: any, obj2: any): boolean {
        // Deep comparison similar to Lodash.isEqual
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }

    trackByIndex (index: number): number {
        return index;
    }
}
